import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/ScoreColors`
//#region AttachSetting相关
const GetList = `${apiUrl}`
const PostData = `${apiUrl}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export class ScoreColorsData {
    [key: string]: any
    Id: number
    Category: number
    MaxScore: number
    MinScore: number
    Color: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date
    constructor() {
        this.Id = 0
        this.Category = 0
        this.MaxScore = 1
        this.MinScore = 1
        this.Color = ''
        this.Status = 0
        this.NewUserId = 0
        this.NewDate = new Date()
        this.UpdateUserId = 0
        this.UpdateDate = new Date()
    }
}
export const emptyData: ScoreColorsData = new ScoreColorsData()

export const getList = () => {
    return tryAxios({
        method: 'get',
        url: GetList
    })
}

export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}

